import { Component, Input, OnInit } from '@angular/core';

import { EnvironmentService } from '@patient-ui/shared-ui/utils';

@Component({
  selector: 'ui-registered-footer',
  templateUrl: './registered-footer.component.html',
  styleUrls: ['./registered-footer.component.scss'],
})
export class RegisteredFooterComponent implements OnInit {
  @Input() appName = 'AppName';
  @Input() browserTarget = '_blank';
  appYear: number = new Date().getFullYear();
  isMobile = false;
  patientUserAgreement = '';

  constructor(private envService: EnvironmentService) {}

  ngOnInit(): void {
    this.patientUserAgreement = this.envService.userAgreementUrl;
    if (this.browserTarget === '_system') {
      this.isMobile = true;
    }
  }

  goToTop() {
    window.scrollTo(0, 0);
  }
}
